import { Button } from 'src/v2/commonComponents/Button';
import { SubscriptionInfo } from 'src/types';
import { useSession } from 'src/hooks';
import { toast } from 'react-toastify';
import log from 'src/utils/logger';
import { useResumeSubscriptionMutation } from 'src/store/services';

type RenewSubscriptionButtonProps = {
  subscriptionInfo?: SubscriptionInfo;
  isSubscriptionInfoLoading?: boolean;
  isAppleOrAmpPayment?: boolean;
};

export const RenewSubscriptionButton = ({
  subscriptionInfo,
  isSubscriptionInfoLoading,
  isAppleOrAmpPayment,
}: RenewSubscriptionButtonProps) => {
  const { appUser } = useSession();

  const [resumeSubscription, { isLoading: isResumeSubscriptionLoading }] =
    useResumeSubscriptionMutation();

  const isRenewDisabled =
    isResumeSubscriptionLoading ||
    isSubscriptionInfoLoading ||
    subscriptionInfo?.processing_plan_change ||
    isAppleOrAmpPayment ||
    !subscriptionInfo?.can_renew ||
    !!appUser?.stripe_info?.renew_early_pending_subscription;

  const handleRenewClick = async () => {
    if (!subscriptionInfo || !subscriptionInfo?.price_info?.lookup_key) {
      return;
    }

    try {
      await resumeSubscription(appUser.user_id).unwrap();
      toast.success('Subscription renewed successfully.');
    } catch (error) {
      toast.error('Failed to renew subscription.');
      log.error(error);
    }
  };

  return (
    <Button
      color="secondary-outline"
      disabled={isRenewDisabled}
      onClick={handleRenewClick}
    >
      Renew subscription
    </Button>
  );
};
